export default __webpack_public_path__ + "static/media/2mmb.26118397.jpg";